var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "main-content"
  }, [_c('section', {
    staticClass: "section login-form m-0 pb-0"
  }, [_c('div', {
    staticClass: "container-fluid p-0"
  }, [_c('div', {
    staticClass: "container-background",
    class: _vm.platform
  }, [_c('div', {
    staticClass: "row mt-0",
    style: {
      minHeight: `${_vm.containerHeight}px`
    }
  }, [_c('div', {
    staticClass: "col-12 col-md-6 col-lg-5 col-xl-5 p-0"
  }, [_c('div', {
    staticClass: "w-100 h-100 d-flex justify-content-md-end justify-content-lg-end justify-content-xl-end align-items-center"
  }, [_c('div', {
    staticClass: "online-courses-section online-courses-section-size",
    style: {
      paddingRight: _vm.rightPaddingStyle
    }
  }, [_c('div', {
    staticClass: "online-courses-title online-courses-title-text pb-3"
  }, [_vm._v(" Online Courses ")]), _c('div', {
    staticClass: "online-courses-text online-courses-text-container py-3 text-left"
  }, [_vm._v(" " + _vm._s(_vm.onlineCoursesText) + " ")]), _c('div', {
    staticClass: "w-100 pt-3"
  }, [!_vm.isLoggedIn ? _c('div', {
    staticClass: "d-flex flex-column flex-md-row flex-lg-row flex-xl-row justify-content-md-between justify-content-lg-between justify-content-xl-between align-items-center button-container"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'signup'
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "outlined": "",
      "dark": "",
      "width": "180",
      "color": _vm.primaryWhiteColor
    }
  }, [_vm._v(" Register ")])], 1), _c('router-link', {
    attrs: {
      "to": {
        name: 'login',
        query: {
          redirect: this.$route.path
        }
      }
    }
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "width": "180",
      "color": _vm.primaryButtonColor
    }
  }, [_vm._v(" Log In ")])], 1)], 1) : _c('div', {
    staticClass: "d-flex justify-content-center justify-content-md-start justify-content-lg-start justify-content-xl-start align-items-center button-container"
  }, [_c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "outlined": "",
      "dark": "",
      "width": "240",
      "color": _vm.primaryWhiteColor
    },
    on: {
      "click": function ($event) {
        _vm.showGoToEnciteLMSWindow = true;
      }
    }
  }, [_vm._v(" Take Courses on Encite ")])], 1)])])])]), _c('div', {
    staticClass: "col-12 col-md-6 col-lg-7 col-xl-7 p-0 d-flex justify-content-center align-items-center"
  }, [_c('div', {
    staticClass: "courses-image-container"
  }, [_c('img', {
    staticClass: "courses-image",
    attrs: {
      "src": require('@assetsImages/OnlineCoursesImage.png'),
      "alt": "Encite Courses"
    }
  })])])]), _vm.showGoToEnciteLMSWindow ? _c('div', {
    staticClass: "encite-courses-window-container"
  }, [_c('div', {
    staticClass: "course-container-display course-container-size"
  }, [_c('div', {
    staticClass: "course-container-text text-center px-5 mb-2"
  }, [_vm._v(" You are now leaving Project Spectrum to access an external webiste. ")]), _c('div', {
    staticClass: "d-flex flex-column flex-lg-row flex-xl-row justify-content-between align-items-center button-space-between px-3 mt-2"
  }, [_c('v-btn', {
    staticClass: "mb-md-2",
    attrs: {
      "rounded": "",
      "large": "",
      "outlined": "",
      "dark": "",
      "width": "180",
      "color": _vm.primaryButtonColor
    },
    on: {
      "click": function ($event) {
        _vm.showGoToEnciteLMSWindow = false;
      }
    }
  }, [_vm._v(" Go Back ")]), _c('v-btn', {
    attrs: {
      "rounded": "",
      "large": "",
      "dark": "",
      "width": "180",
      "color": _vm.primaryButtonColor
    },
    on: {
      "click": _vm.handOverToLMS
    }
  }, [_vm._v(" Continue ")])], 1)])]) : _vm._e()])])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }